import { render, staticRenderFns } from "./AddSystem.vue?vue&type=template&id=36402cd7&"
import script from "./AddSystem.js?vue&type=script&lang=js&"
export * from "./AddSystem.js?vue&type=script&lang=js&"
import style0 from "./AddSystem.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports